import { ClientCard } from '@crm/features/clients/components/ClientCard'
import { ClientInfoTabs } from '@crm/features/clients/components/ClientInfoTabs'
import { ImportContract } from '@crm/features/clients/components/ImportContract/ImportContract'
import { TitleSection } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Button, Col, Row } from 'antd'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

export const ClientsDetails = () => {
  const { t } = useLocales()
  const { id } = useParams()
  const [importOpen, setImportOpen] = useState(false)

  return (
    <>
      <TitleSection title={t('menu.customers')}>
        <Button type="primary" onClick={() => setImportOpen(true)}>
          {t('lead.convert_to_client')}
        </Button>
      </TitleSection>
      <Row gutter={10}>
        <Col span={10} md={8} xxl={6}>
          <ClientCard />
        </Col>

        <Col span={14} md={16} xxl={18}>
          <ClientInfoTabs />
        </Col>
      </Row>

      {id && (
        <ImportContract
          open={importOpen}
          clientId={Number(id)}
          onClose={() => setImportOpen(false)}
        />
      )}
    </>
  )
}
